<template>
	<div class="pages">
		<div class="carousel">
			<carousel ref="carousel"></carousel>
		</div>
		<div class="content">
			<el-row :gutter="10">
				<el-col :xs="24" :sm="12" :md="8" :lg="6" class="el_col">
					<div class="hear">
						<el-avatar shape="square" :size="200" fit="cover" :src="hear"></el-avatar>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="16" :lg="18" class="el_col">
					<div class="name">
						一个吃臭豆腐的肥仔 · 程序员
					</div>
				</el-col>
			</el-row>
		</div>
		<div class="content">
			<div class="title">
				肥仔技术栈
			</div>
			<el-row :gutter="10">
				<el-col :xs="24" :sm="12" :md="6" :lg="6" class="el_col" v-for="(item,index) in innList" :key="index">
					<a :href="item.link">
						<div class="items">
							<el-image style="width: 200px; height: 200px" :src="item.img" fit="contain"></el-image>
							<div class="title">
								{{item.title}}
							</div>
						</div>
					</a>
				</el-col>
			</el-row>
		</div>
		<div class="content">
			<div class="title">
				工具站点推荐
			</div>
			<div class="list" v-for="(item,index) in linkList" :key="index">
				<a :href="item.link">{{item.title}}</a>
			</div>
		</div>
		<div class="content">
			<div class="title">
				肥仔多说一句
			</div>
			<div class="list">
				努力！努力努力！努力！
			</div>
		</div>
		<div class="tail">
			<div class="copyright">
				© Copyright 2023 smallfatman.com All Rights Reserved 版权所有
			</div>
			<div class="copyright">
				<a href="https://beian.miit.gov.cn">备案号：粤ICP备2022157120号</a>
				<div style="width:300px;margin:0 auto; padding:20px 0;">
					<a target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011302003863"
						style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img
							src="../../assets/img/beian.png" style="float:left;" />
						<p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备
							44011302003863号</p>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import carousel from '@/components/util/carousel.vue'
	import hear from '@/assets/img/hear.jpg'
	import tap1 from '@/assets/img/tap/tap1.jpg'
	import tap2 from '@/assets/img/tap/tap2.jpg'
	import tap3 from '@/assets/img/tap/tap3.jpg'
	import tap4 from '@/assets/img/tap/tap4.jpg'

	import vue_ from '@/assets/img/logo/vue.jpg'
	import uni_ from '@/assets/img/logo/uni.png'
	import wx from '@/assets/img/logo/wx.webp'
	import php from '@/assets/img/logo/php.svg'
	import jQuery from '@/assets/img/logo/jQuery.png'
	import node from '@/assets/img/logo/node.svg'
	import electron from '@/assets/img/logo/electron.svg'
	import git from '@/assets/img/logo/git.png'

	export default {
		components: {
			carousel
		},
		data() {
			return {
				hear: hear,
				image: [tap1, tap2, tap3, tap4],
				screenWidth: 0,
				innList: [{
					title: 'Vue',
					img: vue_,
					link: 'https://cn.vuejs.org/'
				}, {
					title: 'uni-app',
					img: uni_,
					link: 'https://uniapp.dcloud.net.cn/'
				}, {
					title: '微信小程序(原生)',
					img: wx,
					link: 'https://mp.weixin.qq.com/cgi-bin/wx?token=&lang=zh_CN'
				}, {
					title: 'PHP',
					img: php,
					link: 'https://www.php.net/'
				}, {
					title: 'jQuery',
					img: jQuery,
					link: 'https://jquery.com/'
				}, {
					title: 'Node.js',
					img: node,
					link: 'https://nodejs.org/en/'
				}, {
					title: 'Electron',
					img: electron,
					link: 'https://www.electronjs.org/zh'
				}, {
					title: 'Git',
					img: git,
					link: 'https://git-scm.com/'
				}],
				linkList: [{
					title: '时间戳转换',
					link: 'https://tool.lu/timestamp/'
				}, {
					title: '调色板',
					link: 'https://mycolor.space/'
				}, {
					title: '圆角工具',
					link: 'https://9elements.github.io/fancy-border-radius/#50.30.9.30--.'
				}, {
					title: '文件扩展名',
					link: 'https://www.wenjianbaike.com/filetype.html'
				}, {
					title: 'canvas动画',
					link: 'http://www.bootstrapmb.com/chajian/canvas'
				}]
			}
		},
		mounted() {
			setTimeout(() => {
				this.$refs.carousel.showImage(this.image)
			}, 500)
		},
		methods: {

		},
	}
</script>

<style lang="less">
	.pages {
		width: 100%;

		.carousel {
			width: 100%;

			.carousel_item {
				display: flex;
				align-items: center;
			}
		}

		.content {
			padding: 30px 20px;
			background-color: #ffffff;
			margin-top: 10px;
			border-radius: 5px;

			.hear,
			.name {
				display: flex;
				align-items: center;
			}

			.hear {
				justify-content: center;
			}

			.name {
				padding: 25px 0 0;
				font-size: 42px;
				font-weight: bold;
				text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px,
					rgba(61, 61, 61, 0.3) 3px 3px, rgba(61, 61, 61, 0.3) 4px 4px;
			}

			.title {
				font-size: 20px;
				font-weight: bold;
				padding: 0 0 15px;
			}

			.items {
				display: flex;
				flex-direction: column;
				align-items: center;

				.title {
					padding: 16px 0 20px;
				}
			}

			.list {
				display: flex;
				align-items: center;
				font-size: 16px;
				padding: 5px 5%;
			}

		}


		.tail {
			padding: 30px 20px 0;
			margin-top: 30px;
			background-color: #C1C1C1;

			.copyright {
				text-align: center;

				a {
					margin: 0 10px;
				}
			}
		}
	}
</style>
